module.exports = __webpack_public_path__ + "static/media/tick.6761cfc0.svg";